export default{
  // eslint-disable-next-line no-unused-vars
  SET_AUTH(state, { accessToken, tokenType, expiresIn}) {
    state.accessToken = accessToken;
    state.tokenType = tokenType;
    state.expiresIn = expiresIn;
  },
  SET_USER(state, { user }) {
    state.user = user;
  },
  SET_FROM_APPS(state, { status }) {
    state.fromApps = status;
  },
  SET_USER_SOCIAL(state, { token, name, email, method, uid}) {
    state.userSocial = {
      token, name, email, method, uid
    };
  },
  REMOVE_USER_SOCIAL(state) {
    state.userSocial = {
      name:'',
      email:'',
      token:'',
      method:'',
      uid:''
    };
  },
};



// WEBPACK FOOTER //
// ./src/stores/Auth/mutations/index.js